import { useSessionStorage } from "@vueuse/core";
import { computed, ref } from "vue";
import clone from "lodash-es/clone";

const defaultUser = {
  name: null,
  email: null,
  role: null,
};

const userStorage = useSessionStorage("user", clone(defaultUser));

const isAuthenticated = ref(false);
const isAdmin = computed(() => ["ADMIN", "SUPER_ADMIN"].includes(userStorage.value?.role));
const isSuperAdmin = computed(() => userStorage.value?.role === "SUPER_ADMIN");
const authChanged = computed(() => ({
  user: userStorage.value,
  isAuthenticated: isAuthenticated.value,
}));

const authStore = {
  user: userStorage,
  isAuthenticated,
  isAdmin,
  isSuperAdmin,
  authChanged,

  getIsAuthenticated: () => isAuthenticated.value,
  setIsAuthenticated(value) {
    isAuthenticated.value = value;
  },
  hasRole: (roles) => roles.includes(userStorage.value?.role),

  setAuthUser(userData) {
    if (userData) {
      userStorage.value = {
        name: userData.name,
        email: userData.email,
        role: userData.role,
      };
      isAuthenticated.value = true;
    }
  },

  clear() {
    isAuthenticated.value = false;
    userStorage.value = clone(defaultUser);
  },
};

export default authStore;
